import { memo } from 'react';

import classnames from 'classnames';

import { IconTick } from '@picsart/design-system/foundation/icons/IconTick';
import { IconWarningCircleFilled } from '@picsart/design-system/foundation/icons/IconWarningCircleFilled';
import { IconInfoOutline } from '@picsart/design-system/foundation/icons/IconInfoOutline';
import type { ToastType, ToastAction } from '@/hooks/useToast';
import useStyles from './styles';

const SuccessIcon = () => (
  <IconTick fill="currentColor" width={16} height={16} />
);
const ErrorIcon = () => (
  <IconWarningCircleFilled fill="currentColor" width={16} height={16} />
);
const InfoIcon = () => (
  <IconInfoOutline fill="currentColor" width={16} height={16} />
);

interface ToastProps {
  message: string;
  type?: ToastType;
  action?: ToastAction;
  onActionClick?: () => void;
}

const ToastComponent = ({
  message,
  type = 'success',
  action,
  onActionClick,
}: ToastProps) => {
  const classes = useStyles();

  const Icon =
    type === 'error' ? ErrorIcon : type === 'info' ? InfoIcon : SuccessIcon;

  const handleActionClick = () => {
    action?.onClick();
    onActionClick?.();
  };

  return (
    <div className={classnames(classes.toast, classes[type])}>
      <div className={classes.content}>
        <Icon />
        {message}
      </div>
      {action && (
        <button
          type="button"
          className={classes.actionButton}
          onClick={handleActionClick}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export const Toast = memo(ToastComponent);
export default Toast;
